import React, { useState, useRef } from 'react'
import { Typography, withStyles } from '@material-ui/core'
import { CoreTextField } from 'src/components/core'
import styles from '../styles'

const EditModal = props => {
  const { classes, onSave, title: initialTitle, label = 'Title' } = props

  // Use ref to capture the initial title and never change it
  // This prevents the value from resetting when Redux updates
  const initialTitleRef = useRef(initialTitle || '')
  const [title, setTitle] = useState(initialTitleRef.current)

  // Also keep a ref of the current title for immediate access
  const currentTitleRef = useRef(initialTitleRef.current)

  const handleTitleChange = e => {
    const newValue = e.target.value
    setTitle(newValue)
    currentTitleRef.current = newValue // Update ref immediately
    if (onSave) {
      onSave({ title: newValue })
    }
  }

  return (
    <div>
      <div className={classes.section}>
        <div>
          <Typography fontSize="14px" fontWeight={500} fontFamily="Inter">
            {label}
          </Typography>
        </div>
        <div>
          <CoreTextField
            label=""
            maxRows={3}
            marginTop={false}
            minRows={3}
            fullWidth
            value={title || ''}
            onChange={handleTitleChange}
            placeholder={label}
            variant="outlined"
            size="medium"
          />
        </div>
      </div>
    </div>
  )
}

export default withStyles(styles)(EditModal)
